import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { generateBirthdaySVG } from '../utils/birthdayTemplates';
import { getBirthdayTemplates } from '../utils/birthdayTemplates';

const BirthdayCardModal = ({ onSend, onClose }) => {
  const { t } = useTranslation();
  
  const [message, setMessage] = useState('');
  const [recipientName, setRecipientName] = useState('');
  const canvasRef = useRef(null);
const [isSending, setIsSending] = useState(false);

// ← générer les templates avec t disponible
  const BIRTHDAY_TEMPLATES = getBirthdayTemplates(t);
 const [selectedTemplate, setSelectedTemplate] = useState(BIRTHDAY_TEMPLATES[0].id);
  const currentSVG = generateBirthdaySVG(selectedTemplate, recipientName, message, t);

  const handleSend = async () => {
setIsSending(true);
    const svgWithSize = currentSVG.replace(
      '<svg',
      '<svg width="600" height="400" shape-rendering="geometricPrecision" text-rendering="geometricPrecision"'
    );

    const blob = new Blob([svgWithSize], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const img = new Image();

    img.onerror = (err) => console.error('Erreur chargement SVG:', err);

    img.onload = () => {
      const canvas = canvasRef.current;
      const scale = 2;
      canvas.width = 600 * scale;
      canvas.height = 400 * scale;

      const ctx = canvas.getContext('2d');
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.scale(scale, scale);
      ctx.drawImage(img, 0, 0, 600, 400);

      URL.revokeObjectURL(url);

      canvas.toBlob((pngBlob) => {
  //console.log('📦 pngBlob size:', pngBlob?.size, 'type:', pngBlob?.type);
  if (!pngBlob || pngBlob.size === 0) {
    console.error('❌ Canvas vide !');
    return;
  }

  // ← Ne pas utiliser new File() sur Android — passer le Blob directement
  const fileName = `birthday-card-${Date.now()}.png`;
  
  // Créer un objet simple compatible avec handleSendMessage
  const fileObj = new Blob([pngBlob], { type: 'image/png' });
  Object.defineProperty(fileObj, 'name', { value: fileName, writable: false });
  Object.defineProperty(fileObj, 'lastModified', { value: Date.now(), writable: false });

  //console.log('✅ fileObj:', fileObj.name, fileObj.type, fileObj.size, typeof fileObj.type);
  onSend(fileObj);
}, 'image/png');
    };

    img.src = url; // ← toujours après img.onload
  };

  return (
    <div className="birthday-modal-overlay" onClick={onClose}>
      <div className="birthday-modal" onClick={e => e.stopPropagation()}>
        <button className="btn-close" onClick={onClose}>✕</button>
        <h3>🎂 {t('birthday_card.title')}</h3>

	{/* ← Champ prénom destinataire */}
        <input
          type="text"
          placeholder={t('birthday_card.recipient_placeholder')}
          value={recipientName}
          onChange={e => setRecipientName(e.target.value)}
          maxLength={40}
          style={{ width: '100%', marginBottom: '10px' }}
	
        />
        

        {/* Sélecteur de style */}
        <div className="birthday-styles">
          {BIRTHDAY_TEMPLATES.map(tpl => (
            <button
              key={tpl.id}
              className={`style-btn ${selectedTemplate === tpl.id ? 'active' : ''}`}
              onClick={() => setSelectedTemplate(tpl.id)}
            >
              {tpl.label}
            </button>
          ))}
        </div>
	
        {/* Message personnalisé */}
        <textarea
          placeholder={t('birthday_card.message_placeholder')}
          value={message}
          onChange={e => setMessage(e.target.value)}
          maxLength={200}
          rows={2}
	style={{ width: '100%'}}
          className="textarea"
        />
        <span style={{ fontSize: '0.75rem', opacity: 0.6 }}>
          {message.length}/200
        </span>

        {/* Aperçu SVG en temps réel */}
        <div
          className="birthday-preview"
          dangerouslySetInnerHTML={{ __html: currentSVG }}
        />

        {/* Bouton envoyer */}
<div style={{ display: 'flex', gap:'20px', alignItems: 'center' }}>
<span>
        <button
          className="buttonFile1"
          onClick={handleSend}
disabled={isSending}
                  >
         {isSending ? '⏳' : '📤'} {t('birthday_card.send')}
        </button>
</span>

{isSending && (
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px' }}>
    <div className="spinner"></div>
    <span style={{ fontSize: '0.9rem', color: '#007bff' }}>
      {t('discussion.moderate') || 'Envoi en cours...'}
    </span>
  </div>
)}
</div>
        <canvas ref={canvasRef} style={{ display: 'none' }} />
      </div>
    </div>
  );
};

export default BirthdayCardModal;